// 코드 발급 랜딩(RandingStyle*) 공통 동의 영역
// [전체 동의 / 상담·예약 서비스 제공 동의(필수) / 마케팅 정보 수신(선택)]
//
// 상세 본문은 한 번에 하나만 펼쳐지며, 필수 항목 본문은 호출부에서 넘긴다
// (랜딩마다 저장된 방침 HTML이 다르기 때문).

import React, { useState } from "react";
import MarketingContent from "./MarketingContent";
import "./randingConsent.scss";

function RandingConsent({
  isAgreed,
  setIsAgreed,
  isMarketingAgreed,
  setIsMarketingAgreed,
  privacyContent,
  companyName = "본원",
  legacyMarketing = false,
  className = "",
}) {
  // null | 'privacy' | 'marketing'
  const [openDetail, setOpenDetail] = useState(null);

  const toggle = (kind) => setOpenDetail((prev) => (prev === kind ? null : kind));

  return (
    <div className={`randing-consent ${className}`.trim()}>
      <div className="randing-consent-rows">
        <div className="randing-consent-row all">
          <label>
            <input
              type="checkbox"
              checked={isAgreed && isMarketingAgreed}
              onChange={(e) => {
                setIsAgreed(e.target.checked);
                setIsMarketingAgreed(e.target.checked);
              }}
            />
            <span>전체 동의</span>
          </label>
        </div>

        <div className="randing-consent-row">
          <label>
            <input
              type="checkbox"
              checked={isAgreed}
              onChange={(e) => setIsAgreed(e.target.checked)}
            />
            <span>상담/예약 서비스 제공 동의 (필수)</span>
          </label>
          <button
            type="button"
            className="randing-consent-toggle"
            onClick={() => toggle("privacy")}
          >
            [{openDetail === "privacy" ? "접기" : "자세히보기"}]
          </button>
        </div>

        <div className="randing-consent-row">
          <label>
            <input
              type="checkbox"
              checked={isMarketingAgreed}
              onChange={(e) => setIsMarketingAgreed(e.target.checked)}
            />
            <span>마케팅 정보 수신 (선택)</span>
          </label>
          <button
            type="button"
            className="randing-consent-toggle"
            onClick={() => toggle("marketing")}
          >
            [{openDetail === "marketing" ? "접기" : "자세히보기"}]
          </button>
        </div>
      </div>

      {openDetail === "privacy" && (
        <div className="randing-consent-detail">{privacyContent}</div>
      )}

      {openDetail === "marketing" && (
        <div className="randing-consent-detail">
          <MarketingContent companyName={companyName} legacy={legacyMarketing} />
        </div>
      )}
    </div>
  );
}

export default RandingConsent;
